import { outGoingErrorPayLoad, outGoingRequestPayLoad, outGoingSuccessPayLoad } from "../interfaces/outGoing"
import { Types } from "../types"
import { outGoingError, outGoingRequest, outGoingReset, outGoingSuccess } from "../types/outGoing/actionsType"


export const outGoingRequestAction = (payload: outGoingRequestPayLoad): outGoingRequest => ({
    type: Types.OUGOING_CALL_REQUEST,
    payload
})

export const outGoingSuccessAction = (payload: outGoingSuccessPayLoad): outGoingSuccess => ({
    type: Types.OUGOING_CALL_SUCCESS,
    payload
})

export const outGoingErrorAction = (payload: outGoingErrorPayLoad): outGoingError => ({
    type: Types.OUGOING_CALL_ERROR,
    payload
})


export const outGoingResetAction = (): outGoingReset => ({
    type: Types.RESET_OUTGOING_CALL,
})
